import React from 'react';
import QuickSearch from './QuickSearch';

export default (props) => <QuickSearch {...props} />;
